// ── Utilitários de tempo/formatação (puros) ─────────────────────────────────

export function minutesToHuman(min) {
  const h = Math.floor(min/60), m = min%60;
  if (m === 0) return `${h}h`;
  if (h === 0) return `${m}min`;
  return `${h}h${String(m).padStart(2,"0")}`;
}
export function timeToMinutes(t) { const [h,m]=t.split(":").map(Number); return h*60+m; }
export function formatTimer(sec) {
  const h=Math.floor(sec/3600), m=Math.floor((sec%3600)/60), s=sec%60;
  return `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
}

// Round to nearest "nice" block: 30, 60, 90, 120 min
export function roundToBlock(min) {
  const blocks=[30,60,90,120,150,180,210,240];
  return blocks.reduce((prev,curr)=>Math.abs(curr-min)<Math.abs(prev-min)?curr:prev);
}
